import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiUser } from 'react-icons/fi';

const NewsCard = ({ news, featured = false }) => {
  return (
    <article className={`bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden border border-gray-100 flex flex-col h-full ${featured ? 'md:col-span-2 md:flex-row' : ''}`}>
      <div className={`relative overflow-hidden ${featured ? 'md:w-1/2 h-64 md:h-auto' : 'h-48'}`}>
        <img 
          src={news.image} 
          alt={news.title} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-primary text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
            {news.category}
          </span>
        </div>
      </div>
      
      <div className={`p-6 flex flex-col justify-between ${featured ? 'md:w-1/2' : 'flex-1'}`}>
        <div>
          <div className="flex items-center text-gray-500 text-xs mb-3 gap-3">
            <span className="flex items-center gap-1"><FiClock /> {news.date}</span>
            <span className="flex items-center gap-1"><FiUser /> {news.author}</span>
          </div>
          
          <h3 className={`font-serif font-bold text-gray-900 mb-3 hover:text-primary transition-colors ${featured ? 'text-2xl' : 'text-lg'}`}>
            <Link to={`/news/${news.id}`}>{news.title}</Link>
          </h3>
          
          <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
            {news.excerpt}
          </p>
        </div>
        
        <Link 
          to={`/news/${news.id}`} 
          className="text-primary font-semibold text-sm hover:underline inline-flex items-center"
        >
          Read Full Story &rarr;
        </Link>
      </div>
    </article>
  );
};

export default NewsCard;